module.exports = __webpack_public_path__ + "static/media/calculator.34561c3b.jpg";